import { Row, Col, Card, Form } from 'react-bootstrap';
import { Field, Formik } from "formik"
import es from 'react-phone-input-2/lang/es.json'
import PhoneInput from 'react-phone-input-2';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import {useEffect} from "react";
import {IkeNowUrl} from "../../../utils/ikeNowUrl";
import {useWalmartUrl} from "../../../utils/walmartUrl";

export default function MexForm({classTop='', data, setData, setCurrentScreen}){
    const {t} = useTranslation()
    const ikeNow = IkeNowUrl()
    const { isWalmart } = useWalmartUrl()

    useEffect(() => {
        if (ikeNow || isWalmart) {
            return setCurrentScreen("mexEspecialidad")
        }
    }, [setCurrentScreen, ikeNow, isWalmart]);

    const shemaValidateStepOne = Yup.object().shape({
        name: Yup.string()
          .required(t('Camporequerido')),
        lastName: Yup.string()
          .required(t('Camporequerido')),
        phoneNumber: Yup.string()
          .required(t('Camporequerido'))
          .min(12,'Campo inválido')
          .max(12,'Campo inválido'),
        phoneNumber2: Yup.string()
          .required(t('Camporequerido'))
          .min(12,'Campo inválido')
          .max(12,'Campo inválido'),
        email: Yup.string()
           .email(t('Correoinvalido'))
           .required(t('Camporequerido')),
        aceptarTerminos: Yup.bool().oneOf([true], 'Debes aceptar los términos y condiciones'),        
    });

    return (
        <Row className={classTop}>
            <Col xs="12" md={{span: 10, offset: 1}}>
                <Card className='mt-2 mb-5 shadow-sm'>
                    <Card.Body>
                        <Formik
                            initialValues={{
                                name: data.patient.name,
                                middleName: data.patient.middleName,
                                lastName: data.patient.lastName,
                                seccondSurname: data.patient.seccondSurname,
                                externalId: data.patient.externalId,
                                email: data.patient.email,
                                phoneNumber: data.patient.phoneNumber,
                                phoneNumber2: data.patient.phoneNumber2,
                                aceptarTerminos: true
                            }}
                            validationSchema={shemaValidateStepOne}
                            onSubmit={(values) => {
                                console.log(values)
                                setData(prev=>({
                                    ...data,
                                    ...values
                                }))
                                setCurrentScreen("mexEspecialidad")
                            }}
                        >{({
                            errors,
                            handleSubmit,
                            setFieldValue,
                            setFieldError,
                            values
                        })=>(
                            <Form onSubmit={handleSubmit}>
                                <h5 className="colorLink text-center mb-4">Información del Paciente</h5>
                                <Row>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className='fw-medium'>Nombre *</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-input text-uppercase ${errors.name && 'error'}`}
                                                name="name"
                                                onChange={e=>{
                                                    setFieldValue('name', e.target.value.toUpperCase())
                                                }}
                                            />
                                            { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className='fw-medium'>Segundo nombre </Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-input text-uppercase`}
                                                name="middleName"
                                                onChange={e=>{
                                                    setFieldValue('middleName', e.target.value.toUpperCase())
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className='fw-medium'>Primer apellido *</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-input text-uppercase ${errors.lastName && 'error'}`}
                                                name="lastName"
                                                onChange={e=>{
                                                    setFieldValue('lastName', e.target.value.toUpperCase())
                                                }}
                                            />
                                            { errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className='fw-medium'>Segundo apellido</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-input text-uppercase`}
                                                name="seccondSurname"
                                                onChange={e=>{
                                                    setFieldValue('seccondSurname', e.target.value.toUpperCase())
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="fw-medium">Poliza </Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-input ${errors.externalId && 'error'}`}
                                                name="externalId"
                                            />
                                            <Form.Text muted className='m-0'>Este campo no es obligatorio</Form.Text>                                                
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="fw-medium">Email *</Form.Label>
                                            <Field 
                                                type="text"
                                                className={`form-input ${errors.email && 'error'}`}
                                                name="email"
                                            />
                                            { errors.email && <div className="invalid-feedback d-block">{errors.email}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="fw-medium">Teléfono *</Form.Label>
                                            <PhoneInput
                                                containerClass="phone2"
                                                inputClass={`form-input`}
                                                buttonClass="btn-phone2"
                                                country={'mx'}
                                                countryCodeEditable={false}
                                                enableSearch={true}
                                                preferredCountries={['mx', 'co']}
                                                disableSearchIcon={true}
                                                localization={es}
                                                value={values.phoneNumber}
                                                onChange={(phone, country, e, formattedValue) => {
                                                    setFieldValue('phoneNumber', phone)                                             
                                                }}
                                            />
                                            { errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="fw-medium">Teléfono alternativo *</Form.Label>
                                            <PhoneInput
                                                containerClass="phone2"
                                                inputClass={`form-input`}
                                                buttonClass="btn-phone2"
                                                country={'mx'}
                                                countryCodeEditable={false}
                                                enableSearch={true}
                                                preferredCountries={['mx', 'co']}
                                                disableSearchIcon={true}
                                                localization={es}
                                                value={values.phoneNumber2}
                                                onChange={(phone, country, e, formattedValue) => {
                                                    setFieldValue('phoneNumber2', phone)      
                                                }}
                                            />
                                            { errors.phoneNumber2 && <div className="invalid-feedback d-block">{errors.phoneNumber2}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="12">
                                        <Form.Group className="text-center">
                                            <Field 
                                                type="checkbox"
                                                rows="3"
                                                className={`${errors.aceptarTerminos && 'error'} mr-2`}
                                                name="aceptarTerminos"
                                            />                                    
                                            <Form.Label className="fw-medium">
                                                <a 
                                                    href="https://ikeasistencia.com/aviso-legal-y-de-privacidad/" 
                                                    target="blank"
                                                    className="label text-underline"
                                                >
                                                    Acepto Términos y Condiciones
                                                </a>                                        
                                            </Form.Label>
                                            { errors.aceptarTerminos && <div className="invalid-feedback d-block">{errors.aceptarTerminos}</div> }
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="12" className='text-center'>
                                        <button
                                            type="submit"
                                            className='mt-2 mb-4'
                                        >
                                            Continuar
                                        </button>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                        </Formik>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )

}